import React from 'react'
import Popup from '../../popup'
import './style.css'
import UploadFile from './components/UploadFile'
import useFileUpload from './useFileUpload'
import { Block } from '@/components/crRender'

const FileUploadPopup = ({
    name,
    title = 'upload-files',
    onUpload,
    onClose,
    large = true,
    accept = 'image/*',
    multiple = false,
    hintSection,
    isLoading,
    maxFiles = 5,
    maxFileSize = 10 * 1024 * 1024,
    recordID = '',
    modalID
}) => {
    const { fileInputRef, files, previews, isDragging, errors, handleFileSelect,
        handleDragEnter, handleDragOver, handleDragLeave, handleDrop, handleRemoveFile,
        handleClose, handleUpload, getFileIcon, formatFileSize } = useFileUpload({ name, recordID, accept, multiple, maxFiles, maxFileSize, onUpload, onClose })


    return (
        <Popup large={large} name={name} recordID={recordID} title={title} onApply={handleUpload}
            modalID={modalID} btnName={isLoading ? "loading" : "upload"} resetAllFields={handleClose} >


            <Block isRender={hintSection} className="file-upload-popup-content">{hintSection}</Block>
            <UploadFile
                accept={accept}
                multiple={multiple}
                maxFiles={maxFiles}
                maxFileSize={maxFileSize}
                fileInputRef={fileInputRef}
                files={files}
                previews={previews}
                isDragging={isDragging}
                errors={errors}
                handleFileSelect={handleFileSelect}
                handleDragEnter={handleDragEnter}
                handleDragOver={handleDragOver}
                handleDragLeave={handleDragLeave}
                handleDrop={handleDrop}
                handleRemoveFile={handleRemoveFile}
                getFileIcon={getFileIcon}
                formatFileSize={formatFileSize}
            />
        </Popup>
    )
}

export default FileUploadPopup
